import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["rounded-full cursor-pointer", { 'loading-animation': _ctx.image.length == 0 }]),
    style: _normalizeStyle({
      width: '27px',
      height: '27px',
      'background-image': 'url(' + _ctx.image + ')',
      'background-size': '27px 27px',
    })
  }, null, 6))
}